import { isAbsent } from '../../utils/absences';
import { fmtDate, uid } from '../../utils/format';
import { phaseBrickId } from '../../utils/phases';
import {
  devAssignedHoursOnDay,
  findWorkedDay,
  lastWorkedDay,
  maxHoursPerDay,
} from '../../utils/planning';

export function createPlanningActions({ absencesByDev, appState }) {
  // Prépare une affectation pour un dev sur une période (vue Par projet, multi-dev).
  // Valide silencieusement (clamp fin sur dernier jour travaillé, conflits absence/surcharge)
  // et renvoie { row } prêt à insérer, ou { skip: 'raison' } si impossible.
  function tryCreateAssignment(devId, clientId, briqueId, debut, fin, heuresParJour, phaseId) {
    const dev = appState.devs.find((d) => d.id === devId);
    if (!dev) return { skip: 'introuvable' };
    const devWorkDays = dev.joursTravailles || [];
    const maxH = maxHoursPerDay(dev);
    const newH = parseFloat(heuresParJour);
    const devAbs = absencesByDev[devId] || [];
    // Clamp la fin sur le dernier jour réellement travaillé de la plage
    let effectiveFin = fin;
    if (devWorkDays.length > 0) {
      const lastValid = lastWorkedDay(debut, fin, devWorkDays);
      if (!lastValid) return { skip: 'aucun jour travaillé sur la période' };
      effectiveFin = lastValid;
    }
    if (dev.dateFinContrat) {
      if (debut > dev.dateFinContrat)
        return { skip: `contrat terminé le ${fmtDate(dev.dateFinContrat)}` };
      if (effectiveFin > dev.dateFinContrat) effectiveFin = dev.dateFinContrat;
    }
    const blocage = findWorkedDay(debut, effectiveFin, devWorkDays, (iso) => {
      if (isAbsent(devAbs, iso)) return 'absent sur la période';
      if (devAssignedHoursOnDay(appState.affectations, devId, iso) + newH > maxH + 0.001)
        return `surcharge (> ${maxH}h/j)`;
      return undefined;
    });
    if (blocage) return { skip: blocage };
    const effectiveBrickId = briqueId || (phaseId ? phaseBrickId(phaseId) : null);
    if (!effectiveBrickId) return { skip: 'phase non choisie' };
    const row = { id: uid(), dev_id: devId, brique_id: effectiveBrickId, debut };
    return { row: { ...row, fin: effectiveFin, heures_par_jour: newH } };
  }

  return { tryCreateAssignment };
}
